import { ICargoData, ICargoType } from '../entities/cargoesData'
import { cargoesData } from '../entities/cargoesData-sidecar'
import { l } from '../lib/imports'
import { machines } from '../machines/machines-sidecar'
import { scene } from '../main/scene-sidecar'
import { IStackSelector } from '../tiles/stackSelectors'
import { stackSelectors } from '../tiles/stackSelectors-sidecar'
import { clickEater } from '../uiParts/clickEater-sidecar'
import { cursors } from './cursors-sidecar'
import { IDialog } from '../uiParts/dialogs'
import { dialogs } from '../uiParts/dialogs-sidecar'
import { IStevieText } from '../uiParts/stevieText'
import { stevieText } from '../uiParts/stevieText-sidecar'

interface IData {
  isOpen: boolean
  isCreated: boolean
  dialog: dialogs.IDialog
  cargoSelectors: IStackSelector[]
  textName: IStevieText
  textDesc: IStevieText
  texts: IStevieText[]
}
let _data: IData | null = null
export const getData = () => {
  if (!_data) {
    let ctx = scene.getContext()

    let x = 20
    let y = 100

    let texts: IStevieText[] = []

    let dialog: IDialog = dialogs.create(20, 20, x, y, 'Pile options', () => {
      setOpen(false)
    })

    let textName = stevieText.create(ctx.font24, x + 200, y + 50)
    stevieText.setText(textName, 'Name')
    texts.push(textName)
    let textDesc = stevieText.create(ctx.font16, x + 200, y + 75)
    stevieText.setText(textDesc, 'Description')
    texts.push(textDesc)

    _data = {
      isOpen: false,
      isCreated: false,
      dialog,
      cargoSelectors: [],
      textName,
      textDesc,
      texts,
    }
    setOpen(false)
  }
  return _data
}

export const toggle = () => {
  setOpen(!getData().isOpen)
}

export const setDesc = (name: string, desc: string) => {
  let data = getData()
  stevieText.setText(data.textName, name)
  stevieText.setText(data.textDesc, desc)
}

export const setOpen = (isOpen: boolean) => {
  clickEater.update('uiStack', isOpen)

  let data = getData()
  data.isOpen = isOpen
  dialogs.setVisible(data.dialog, isOpen)
  stevieText.setBulkVisible(data.texts, isOpen)

  let xs = data.dialog.x + 25
  let xm = xs + 200
  let x = xs
  let y = data.dialog.y + 100
  let size = 75
  if (isOpen && !data.isCreated) {
    data.isCreated = true

    const onOver = (cd: ICargoData) => {
      setDesc(cd.buildName, cd.buildDesc)
    }

    const onClick = (cd: ICargoData) => {
      let ctx = scene.getContext()
      setOpen(false)

      let mc = cursors.getSelectedMachine(ctx.cursor)
      if (mc) {
        machines.setHoldsType(mc, cd.type)
      }

      // Change our active machine
    }

    let stacks: ICargoType[] = cargoesData.stackTypes

    let adv = () => {
      x += size
      if (x > xm) {
        x = xs
        y += size
      }
    }

    l.forEach(stacks, (c) => {
      console.log(c)
      data.cargoSelectors.push(stackSelectors.create(x, y, c, onOver, onClick))
      adv()
    })
  }

  l.forEach(data.cargoSelectors, (c) => {
    stackSelectors.setVisible(c, isOpen)
  })
}

export const update = () => {
  let data = getData()

  if (!data.isOpen) {
    return
  }

  let ctx = scene.getContext()
  l.forEach(data.cargoSelectors, (c) => {
    let isSelected = false
    let mc = cursors.getSelectedMachine(ctx.cursor)
    if (mc) {
      if (mc.holdsType === c.cargoType) {
        isSelected = true
      }
    }

    stackSelectors.setSelected(c, isSelected)
  })
}
